import React from 'react';

/**
 * Lattice Settings Panel - Advanced settings for lattice grid parameters
 */
export const LatticeSettings = ({
  showAdvancedSettings,
  setShowAdvancedSettings,
  latticeSpacing,
  setLatticeSpacing,
  latticeWidth,
  setLatticeWidth
}) => {
  return (
    <div className="mt-4 pl-7 border-l-2 border-accent/30">
      <button
        onClick={() => setShowAdvancedSettings(!showAdvancedSettings)}
        className="flex items-center gap-2 text-white font-medium mb-2 hover:text-accent transition-colors"
        data-testid="toggle-advanced-settings"
      >
        <svg 
          className={`w-4 h-4 transition-transform ${showAdvancedSettings ? 'rotate-90' : ''}`} 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
        Lattice Settings
        <span className="text-xs text-text-secondary font-normal">(Advanced)</span>
      </button>
      
      {showAdvancedSettings && (
        <div className="bg-bg-dark p-4 rounded-lg space-y-4 animate-in fade-in duration-200">
          <p className="text-xs text-text-secondary mb-3">
            Adjust lattice grid parameters for flat overhang surfaces
          </p>
          
          {/* Lattice Spacing */}
          <div>
            <label className="block text-white text-sm mb-2">
              Grid Spacing: <span className="text-accent font-semibold">{latticeSpacing.toFixed(1)}mm</span>
            </label>
            <input
              type="range"
              min="1.0"
              max="5.0"
              step="0.5"
              value={latticeSpacing}
              onChange={(e) => setLatticeSpacing(parseFloat(e.target.value))}
              className="w-full h-2 bg-gray-600 rounded-lg appearance-none cursor-pointer accent-accent"
              data-testid="lattice-spacing-slider"
            />
            <div className="flex justify-between text-xs text-text-secondary mt-1">
              <span>1.0mm (Dense)</span>
              <span>5.0mm (Sparse)</span>
            </div>
          </div>
          
          {/* Lattice Width */}
          <div>
            <label className="block text-white text-sm mb-2">
              Line Width: <span className="text-accent font-semibold">{latticeWidth.toFixed(1)}mm</span>
            </label>
            <input
              type="range"
              min="0.4"
              max="1.5"
              step="0.1"
              value={latticeWidth}
              onChange={(e) => setLatticeWidth(parseFloat(e.target.value))}
              className="w-full h-2 bg-gray-600 rounded-lg appearance-none cursor-pointer accent-accent"
              data-testid="lattice-width-slider"
            />
            <div className="flex justify-between text-xs text-text-secondary mt-1">
              <span>0.4mm (Thin)</span>
              <span>1.5mm (Thick)</span>
            </div>
          </div>
          
          {/* Quick Presets */}
          <div className="flex gap-2 mt-3">
            <button
              onClick={() => { setLatticeSpacing(2.0); setLatticeWidth(0.6); }}
              className="flex-1 px-2 py-1.5 text-xs bg-bg-light hover:bg-accent/20 text-text-secondary hover:text-white rounded transition-colors"
              data-testid="lattice-preset-default"
            >
              Default
            </button>
            <button
              onClick={() => { setLatticeSpacing(1.5); setLatticeWidth(0.8); }}
              className="flex-1 px-2 py-1.5 text-xs bg-bg-light hover:bg-accent/20 text-text-secondary hover:text-white rounded transition-colors"
              data-testid="lattice-preset-strong"
            >
              Strong
            </button>
            <button
              onClick={() => { setLatticeSpacing(3.0); setLatticeWidth(0.5); }}
              className="flex-1 px-2 py-1.5 text-xs bg-bg-light hover:bg-accent/20 text-text-secondary hover:text-white rounded transition-colors"
              data-testid="lattice-preset-light"
            >
              Light
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default LatticeSettings;
